import type { FC, SVGProps } from "react";

const FastIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="fast speed video icon">
      {/* <title>fast speed video icon</title> */}
      <path
        d="M21.1275 2.3999C21.7221 2.3999 22.2927 2.86163 22.2927 3.55915V9.8141C22.2927 10.2681 21.9247 10.6359 21.4709 10.6359H15.2245C14.5265 10.6359 14.0644 10.0649 14.0644 9.46984C14.0644 9.18543 14.1699 8.89536 14.4056 8.65957L16.34 6.72435C15.1302 5.7323 13.6027 5.15354 11.9971 5.15354C8.22057 5.15354 5.14625 8.227 5.14625 12.0044C5.14625 15.7818 8.21885 18.8536 11.9958 18.8536C15.1315 18.8536 15.8303 17.2111 16.9303 17.2111C17.7226 17.2111 18.3009 17.8559 18.3009 18.5813C18.3009 20.0835 14.8031 21.5999 11.9988 21.5999C6.70849 21.5999 2.3999 17.2913 2.3999 12.001C2.3999 6.71063 6.70977 2.41405 12.0001 2.41405C14.3409 2.41405 16.5531 3.2882 18.2765 4.78313L20.3172 2.74116C20.553 2.50537 20.8445 2.3999 21.1275 2.3999Z"
        fill={props.fill || "currentColor" || "#F5F5F5"}
      />
    </svg>
  );
};

export default FastIcon;
